"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMenu = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helperFunctions = require("../../../styles/helperFunctions");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// External
var desktopPadding = (0, _styledComponents.css)(["", ""], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
});
var mobilePadding = (0, _styledComponents.css)(["", ""], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 1.5, props.theme.standardPadding);
});

var StyledMenu = _styledComponents.default.div.withConfig({
  displayName: "Menustyles__StyledMenu",
  componentId: "sc-1ds6rp4-0"
})(["background-color:", ";border:none;z-index:", ";.desktop{display:none;@media only screen and (min-width:", "){display:flex;padding:0 ", ";}}.mobile{display:flex;padding:0 ", ";@media only screen and (min-width:", "){display:none;}}.c-menu-grid-wrapper{align-items:stretch;display:flex;flex-direction:column;justify-content:center;}"], function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return props.theme.menu;
}, function (props) {
  return props.theme.smallBreak;
}, desktopPadding, mobilePadding, function (props) {
  return props.theme.smallBreak;
});

exports.StyledMenu = StyledMenu;